export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/journals`,
        name: `${prefix}.journals.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.journals.index`,
                PageDescription: "Inventory management: Journals",
            },
        },
    },
    {
        path: `/${prefix}/journals/create`,
        name: `${prefix}.journals.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.journals.create`,
                PageDescription: "Inventory management: Create Journal",
            },
        },
    },
];
